// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"4f08ca4e","85":"c1bcea92","189":"61476528","207":"adcdc920","295":"4c44c818","867":"e17f080d","869":"d3f2269b"}[chunkId] + ".chunk.js";
};